import { render, staticRenderFns } from "./ThreeDViewer.vue?vue&type=template&id=58094ad2&scoped=true&"
import script from "./ThreeDViewer.vue?vue&type=script&lang=js&"
export * from "./ThreeDViewer.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDViewer.vue?vue&type=style&index=0&id=58094ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58094ad2",
  null
  
)

export default component.exports